import { useTranslation } from 'react-i18next'

import { PercentIcon } from '@phosphor-icons/react'

import { Alert, InputWithLabel, Switch, Text } from '@reveni-io/reveni-ui'

import CurrencySelector from '@/common/components/CurrencySelector/CurrencySelector'
import { getCurrencySymbolByCode } from '@/common/helpers/helpers'

import { errorTypes } from '../constants'
import { getDutiesOrTaxesSwitchChange } from './helpers'
import * as Styles from './styles'

const ShippingMethodCost = ({
  selectedCurrency,
  currencies,
  price,
  onChange,
  errors,
  calculateDuties,
  calculateTaxes,
  calculateHandlingFees,
  dutiesAdjustmentRate,
}) => {
  const { t } = useTranslation()
  const currencySymbol = getCurrencySymbolByCode(selectedCurrency, currencies)
  const isHandlingFeesDisabled = !calculateDuties && !calculateTaxes

  const showError = errorType => {
    return errors.find(error => error.type === errorType)
  }

  const handleChangeCurrency = currency => {
    onChange({ currency })
  }

  const handleChangePrice = event => {
    const price = event.target.value
    onChange({ price })
  }

  const handleChangeCalculateDuties = e => {
    onChange(
      getDutiesOrTaxesSwitchChange({
        field: 'calculate_duties',
        checked: e.target.checked,
        isOtherCalculationEnabled: calculateTaxes,
        calculateHandlingFees,
      })
    )
  }

  const handleChangeCalculateTaxes = e => {
    onChange(
      getDutiesOrTaxesSwitchChange({
        field: 'calculate_taxes',
        checked: e.target.checked,
        isOtherCalculationEnabled: calculateDuties,
        calculateHandlingFees,
      })
    )
  }

  const handleChangeCalculateHandlingFees = e => {
    onChange({ calculate_handling_fees: e.target.checked })
  }

  const handleChangeDutiesAdjustmentRate = event => {
    const dutiesAdjustmentRate = event.target.value
    onChange({ duties_adjustment_rate: dutiesAdjustmentRate })
  }

  return (
    <Styles.Container id={errorTypes.priceOrCurrencyEmpty}>
      <Text type="titleS">{t('Coste del envío')}</Text>
      <CurrencySelector
        currencies={currencies}
        selectedCurrency={selectedCurrency}
        onChange={handleChangeCurrency}
        error={showError(errorTypes.currencyEmpty)}
        helperText={showError(errorTypes.currencyEmpty) ? t('Este campo es obligatorio') : null}
      />
      <Alert type="info">{t('Este precio se convertirá automáticamente a la divisa del checkout del cliente.')}</Alert>
      <InputWithLabel
        label={t('Coste base')}
        startAdornment={currencySymbol}
        type="number"
        value={price}
        onChange={handleChangePrice}
        error={showError(errorTypes.priceEmpty)}
        helperText={showError(errorTypes.priceEmpty) ? t('Este campo es obligatorio') : null}
        fullWidth
      />
      <Styles.TaxesAndDutiesContainer>
        <Switch
          label={t('Sumar aranceles al coste final en la pantalla de pago del pedido')}
          checked={calculateDuties}
          onChange={handleChangeCalculateDuties}
        />
        {calculateDuties && (
          <InputWithLabel
            label={t('Ajuste del coste de aranceles')}
            startAdornment={<PercentIcon size={16} />}
            type="number"
            value={dutiesAdjustmentRate}
            onChange={handleChangeDutiesAdjustmentRate}
            helperText={t(
              'Los valores positivos aumentan los aranceles cobrados al cliente en la pantalla de pago. Los valores negativos los reducen'
            )}
            fullWidth
          />
        )}
        <Switch
          label={t('Sumar impuestos al coste final en la pantalla de pago del pedido')}
          checked={calculateTaxes}
          onChange={handleChangeCalculateTaxes}
        />
        <Switch
          label={t('Sumar tasas de tramitación al coste final en la pantalla de pago del pedido')}
          checked={calculateHandlingFees}
          onChange={handleChangeCalculateHandlingFees}
          disabled={isHandlingFeesDisabled}
        />
      </Styles.TaxesAndDutiesContainer>
      <Alert type="info">
        {t('El precio final del método de envío puede cambiar según los aranceles del país de destino.')}
      </Alert>
    </Styles.Container>
  )
}

export default ShippingMethodCost
